import { ReactNode, CSSProperties } from "react";
import { getCssVar } from "../../types/theme.ts";
import s from "./style.module.scss";

type LayoutProps = {
  children: ReactNode;
  backgroundColor?:
    | "section_dark"
    | "section_light"
    | "section_white"
    | "section_1";
  style?: CSSProperties;
};

const BackgroundColor = {
  section_dark: getCssVar("color_bg_section_dark", "#1C2B54"),
  section_light: getCssVar("color_bg_section_light", "#FBFAF8"),
  section_white: getCssVar("color_bg_white", "#FFF"),
  section_1: getCssVar("color_bg_section_1", "#FFF"),
};

export const PageWrapper = ({
  children,
  backgroundColor = "section_white",
  style,
}: LayoutProps) => (
  <div
    className={s.PageWrapper}
    style={{ background: BackgroundColor[backgroundColor], ...style }}
  >
    <div className={s.PageWrapper__middleSection}>{children}</div>
  </div>
);
